import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'wm-common-overlay-modal',
  templateUrl: './common-overlay-modal.component.html',
  styleUrls: ['./common-overlay-modal.component.scss'],
  standalone: false 
})
export class CommonOverlayModalComponent {
  
  @Input() isOpen: boolean = false;
  // Added by amisha on 17-03-2026 for bodypadding in common overlay modal
  @Input() bodyPadding: string | null = '32px';
  
  @Input() headerTitle: string = '';
  
  @Input() maxWidth: string = '800px';

  @Input() height: string = 'auto';

  @Input() minHeight: string = '';

  @Input() offsetTop: number = 0;

  @Output() closed = new EventEmitter<void>();

  closeModal(): void {
    //this.isOpen = false;
    this.closed.emit();
  }

  handleBackdropClick(): void {
    this.closeModal();
  }
}